import * as React from 'react';
import * as classnames from "classnames"
import { Button, Icon, Balloon } from '@alifd/next';
import doLog from '../../common/log';
import './verify.scss';

export default function AuthCard(props: any) {

  const { i18n, seller } = props;
  const {
    // 付费用户即会员gs
    accountIsPaidMember,
    // 信保亮灯
    baoAccountIsDisplayAssurance,
    // 是gps用户即金品认证用户
    accountIsGoldPlusSupplier,
    companyName,
    homeUrl,
    companyRegisterCountry,
    companyJoinYears,
    companyProfileUrl,
    authCards,
    overseaBrand,
  } = seller;

  if (!authCards.value || !authCards.value.authGroupInfoList || !authCards.value.identityInfo) return null;

  const { value: {
    identityInfo,
    authGroupInfoList
  } } = authCards


  const isGS = accountIsPaidMember && !accountIsGoldPlusSupplier;
  const isGPS = accountIsPaidMember && accountIsGoldPlusSupplier;
  const isIFM = !accountIsPaidMember;
  const cls = classnames(
    'scc-wrapper',
    'detail-module',
    'module-companyCardIntegrated',
    'module-companyCardIntegrated-lite',
    'module-companyCardIntegrated-2022',
    'module-companyCardIntegrated-lite-b',
  );
  const cls1 = classnames(
    'widget-supplier-card',
    'company-card-integrated',
    'company-card-integrated-lite',
    {
      'has-ta': baoAccountIsDisplayAssurance,
      origin: true,
      'gs-background': isGS,
      'gps-background': isGPS,
      'ifm-background': isIFM,
    },
  );

  const renderCompanyType = () => {
    if (overseaBrand || identityInfo.identityName) {
    return <div className='company-brand'>
      {overseaBrand && <img
            src="https://img.alicdn.com/imgextra/i4/O1CN01350gqJ1cjKkuKUxqc_!!6000000003636-2-tps-76-26.png"
            height="14px"
          />}
    <span>{identityInfo.identityName}</span>
  </div>
    }
  };

  const renderBasicItem = (item: any, authGroup: string) => {
    const temp = <>
              {authGroup === 'basicCapacity' && <div className="attr-title" title={i18n[`pc.detail.companyCard.certificates.${item.authName}`]}>
                {item.authName}
              </div>}
              <div className="attr-content" title={item.authValue}>
                {item.authSubInfoList ? item.authSubInfoList.map((i: any) => <img src={`${i.authPhoto}_100x100.jpg`} title={i.authValue} key={i.authKey} />) : item.authValue || item.authName}
              </div>
            </>
    return (item.authRedirectUrl) ? <a href={item.authRedirectUrl} onClick={() => {
      doLog('/sc.details.companyCard', `item=${authGroup}`);
    }} className="attr-item" key={item.authKey}>
      {temp}
    </a> : <div className="attr-item">{temp}</div>
  }

  const renderAbility = (category: any, index: number) => {
    const { authGroup, authInfoList = [], authRedirectUrl } = category;
    if (authInfoList.length === 0) return;
    if (authGroup === 'other') return;
    // 认证能力
    if (authGroup === 'goodwillReputationAbility') {
      return authInfoList.map((item: any) => <div className="ability" key={item.authKey}>
        <img
          src={
            'https://img.alicdn.com/imgextra/i3/O1CN015NySK71aBmY1PTG9K_!!6000000003292-2-tps-28-28.png'
          }
        />
        {item.authValue}
      </div>)
    }

    if (authGroup === 'basicCapacity') {
      return <div className={`company-${authGroup}`}>
            {authInfoList.map((item: any) => {
                if (item.authDesc) {
                  return <Balloon align="tl" trigger={renderBasicItem(item, authGroup)} closable={false}>
                    {item.authDesc}
                </Balloon>
                }
                return renderBasicItem(item, authGroup)
              })}
          </div>
    }

    const renderService = () => {
      return <>
        <div className='attr-title'>{i18n[`pc.detail.companyCard.${authGroup}`]}</div>
        {authInfoList.map((item: any) => {
          if (item.authDesc) {
            return <Balloon align="tl" trigger={renderBasicItem(item, authGroup)} closable={false}>
              <h4>{item.authValue}</h4>
              <p>{item.authDesc}</p>
          </Balloon>
          }
          return renderBasicItem(item, authGroup)
        })}
        </>
  }
    
    if (authRedirectUrl) {
      return <a href={authRedirectUrl} onClick={() => {
        doLog('/sc.details.companyCard', `item=${authGroup}`);
      }} className={`company-${authGroup} service-${index}`}>
        <Icon type="arrow-right" size="xxs"/>
        {renderService()}
        </a>
    }

    return <div className={`company-${authGroup} service-${index}`}>
      {renderService()}
    </div>

  }

  const showRoom = authGroupInfoList.filter((i:any) => i.authGroup === 'other');

  return (
    <div className={cls} data-spm="cordpanyb">
      <div
        className={cls1}
        data-role="widget-supplier-card"
        data-aui="supplier-card"
      >
        {isGS && (
          <div className={`card-central-logo`}>
            <a
              href="//fuwu.alibaba.com/gps/buyer.htm?tracelog=from_widget_supplier_card_esite"
              target="_blank"
              data-aui="ta-ordered"
              onClick={() => {
                doLog('/sc.details.companyCard', 'item=isGS');
              }}
              rel="nofollow"
              title={i18n['widget.supplierCard.gs']}
            >
              <i className="svg-card-icon svg-card-icon-gs" />
              <span>Gold Supplier</span>
            </a>
          </div>
        )}
        {isGPS && (
          <div className={`card-central-logo`}>
            <a
              href="//fuwu.alibaba.com/page/verifiedsuppliers.htm?tracelog=from_widget_supplier_card_plus_esite"
              target="_blank"
              onClick={() => {
                doLog('/sc.details.companyCard', 'item=isGPS');
              }}
              data-aui="ta-ordered"
              rel="nofollow"
            >
              <img
                src="https://img.alicdn.com/imgextra/i1/O1CN01AOhmtZ1HQ08UWY7sf_!!6000000000751-2-tps-266-54.png"
                style={{ height: '27px', width: 'auto' }}
              />
            </a>
          </div>
        )}
        {/* 公司头像、公司名称链接 */}
        <div className="company-name-container">
          <a
            className="company-name company-name-lite-vb"
            href={homeUrl}
            target="_blank"
            title={companyName}
            data-aui="company-name"
            data-domdot="id:3317"
          >
            {companyName}
          </a>
        </div>
        {/* 公司年限、国家、供应商类型 */}
        {renderCompanyType()}
        <div className="card-supplier card-icons-lite">
          {companyRegisterCountry.toLocaleLowerCase() !== 'tw' && companyRegisterCountry && (
            <span className="company-name-country">
              <i
                className={`icbu-icon-flag icbu-icon-flag-${String(
                  companyRegisterCountry,
                ).toLowerCase()}`}
              />
              <span className="register-country">
                {companyRegisterCountry}
              </span>
            </span>
          )}
          {(isGS || isGPS) && (
            <a className="verify-info" data-aui="ggs-icon" rel="nofollow">
              <span className="join-year">
                <span className="value">
                  &nbsp;&nbsp;&nbsp;{companyJoinYears}
                </span>
                <span className="unit">
                  {companyJoinYears == 1 ? 'YR' : 'YRS'}
                </span>
              </span>
            </a>
          )}

          {showRoom.length === 1 && <a href={showRoom[0]?.authInfoList[0]?.authRedirectUrl} onClick={() => doLog('/sc.details.companyCard', 'item=showroom')} className='vr-link'>{i18n["pc.detail.companyCard.vrFactory"]}</a>}
        </div>

        {authGroupInfoList.map((item: any, index:number) => renderAbility(item, index))}

        <div className='company-profile'>
          <Button component="a" href={companyProfileUrl} onClick={() => doLog('/sc.details.companyCard', 'item=button')}>{i18n["navigation.menu_company_profile"]}</Button>
          <Button component="a" href={homeUrl} type='secondary' onClick={() => doLog('/sc.details.companyCard', 'item=button')}>{i18n["pc.detail.companyCard.visitStore"]}</Button>
        </div>
      </div>
    </div>
  );
}
